// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"38":"08614b5a","782":"fabda601"}[chunkId] + ".chunk.js");